import React, { Component } from 'react'
import styles from './extraVirtualRemotes.module.scss'
import SideMenu from '../../components/SideMenu/sideMenu'
import CloseIcon from '../../img/icons/closeIcon'
import API from '../../components/utils/API'
import { notification, Modal, Switch, Result, Button as AntdButton, Input, Skeleton } from 'antd'
import { strings } from '../../components/utils/translations'
import Loader from '../../components/Loader/index'
import classnames from 'classnames'
import { withRouter } from "react-router-dom"
import Button from '../../components/Button/button'
import qs from 'qs'
import InfoIcon from '../../img/icons/info.svg'
import history from '../../components/utils/routes/history'
import { isMobile } from 'react-device-detect'
import SubscriptionView from  './SubscriptionView/SubscriptionView'
import ProductCard from './ProductCard/ProductCard'
import VRBenefits from './VRBenefits/VRBenefits'
import Disclosure from '../../components/Disclosure/Disclosure'
import { buildPricingModel, isFiveYearProduct } from './pricing'
import { Utils } from '../../components/utils/utils'

const OPTION_MANAGE_REMOTES = 'manage_remotes'
const OPTION_BUY_REMOTES = 'buy_remotes'

const SUPPORT_EMAIL = 'hola@homyhub.com'

class ExtraVirtualRemotesPage extends Component
{
    constructor(props)
    {
        super(props)
        
        this.state =
        {
            isLoading: false,
            houses: [],
            selectedHouse: null,
            user: null,
            
            selectedOption: null,
            
            products: [],
            isLoadingProducts: false,
            isDoorsInfoModalVisible: false,
            
            isCreatingSessionProductId: null,
            isCreatingPortalSession: false,
            
            isTrialChecked: false,
            
            isLoadingSubscriptions: false,
            
            searchInput: null,
            
            // Volume accordions start closed on every load
            expandedProductIds: [],
            isBenefitsOpen: false
        }
        
        this.houses = []
        
        this.renderProducts = this.renderProducts.bind(this)
    }
    componentDidMount()
    {
        let searchParams = qs.parse(this.props.location.search, { ignoreQueryPrefix: true })
        let accessToken = searchParams?.access_token
        let userId = searchParams?.user_id
        let houseId = searchParams?.house_id
        let success = searchParams?.success
        let cancelled = searchParams?.cancelled
        
        if (accessToken && userId)
        {
            API.getInstance().setExternalAccessToken(accessToken, userId)
            
            delete searchParams.access_token
            delete searchParams.user_id
            history.push('/extra-virtual-remotes?' + qs.stringify(searchParams))
        }
        
        this.getMyPermissions()
        this.getStripeProducts()
        
        document.body.classList.add('no_min_width', 'extra_vrs')
        
        this.unlisten = this.props.history.listen((location, action) =>
        {
            let sp = qs.parse(location.search, { ignoreQueryPrefix: true })
            if (location.pathname === "/extra-virtual-remotes" &&
                sp?.access_token != null && sp?.user_id != null)
            {
                window.location.reload()
            }
        })
    }
    componentWillUnmount()
    {
        document.body.classList.remove('no_min_width', 'extra_vrs')
        this.unlisten()
    }
    
    render()
    {
        let shouldShowDelegatePayment = this.getShouldShowDelegatePayment()
        let noHouses = this.state.houses.length === 0 && !this.state.isLoading
        let houseHasSubscriptions = this.houseHasSubscriptions(this.state.selectedHouse)
        
        const goBackSection = houseHasSubscriptions &&
                            <div className={styles.goBackSection} onClick={() => this.onClickGoBack()}>
                                <div className={styles.backIcon}></div>
                                <div className={styles.backText}>{ strings('back') }</div>
                            </div>
        
        return (
            <div className="dashboardContainer">
                <SideMenu className="extra_vrs" />
                
                <div className={styles.container}>
                    <div className={classnames(styles.left, noHouses ? styles.noHouses : null)}>
                        <div className={styles.title}>{ strings('extraVirtualRemotes') }</div>
                        {
                            (!noHouses) &&
                            <div className={styles.subtitle}>
                                <span>{ strings('extraVRsubtitle1') }</span>
                                { strings('extraVRsubtitle2') }
                            </div>
                        }
                        
                        { this.state.isLoading && <Loader className={styles.loader} gray large spinner centerHorizontal /> }
                        
                        {
                            (this.houses.length > 3 && (this.state.houses?.length > 0 || this.state.searchInput?.length > 0)) &&
                            <div className={styles.searchInputContainer}>
                                <Input
                                    className={styles.searchInput}
                                    placeholder={strings('garagesSearchPlaceholder')}
                                    allowClear
                                    prefix={
                                        <img
                                            className={styles.searchIcon}
                                            src={require('../../img/icons/magnifyingglass.svg').default}
                                        />
                                    }
                                    onChange={this.onSearchInput.bind(this)}
                                />
                            </div>
                        }
                        
                        { this.renderHouses() }
                    </div>
                    <div id="extraVrsRight" className={classnames(styles.right, noHouses ? styles.noHouses : null)}>
                        {
                            this.state.selectedHouse != null &&
                            <>
                                <div className={styles.title}>
                                    { strings('myVRsIn') } <span className={styles.purple}>{ this.state.selectedHouse?.name }</span>
                                </div>
                                
                                <div className={styles.subtitle}>{ strings('extraVRsubtitleRight') }</div>
                                
                                <div
                                    className={styles.houseDoorsInfoButton}
                                    onClick={() => this.setState({ isDoorsInfoModalVisible: true })}
                                >
                                    <div>{strings('extraVRdoorsInfoButton')}</div>
                                    <img src={InfoIcon} />
                                </div>
                                
                                <div className={styles.rightContent}>
                                    {
                                        houseHasSubscriptions &&
                                        <div className={styles.section}>
                                            <div className={styles.sectionTitle}>{ strings('extraVRoptionQuestion') }</div>
                                            
                                            <div className={styles.sectionContent}>
                                                <div className={styles.optionSelector}>
                                                    <div
                                                        className={classnames(styles.option, 
                                                                      (this.state.selectedOption === OPTION_MANAGE_REMOTES) ? styles.selected : null
                                                        )}
                                                        onClick={() => this.onOptionClick(OPTION_MANAGE_REMOTES)}
                                                    >
                                                        <div className={styles.title}>{ strings('extraVRoptionTitleManage') }</div>
                                                        <div>{ strings('extraVRoptionManage') }</div>
                                                    </div>
                                                    <div className={styles.separator}></div>
                                                    <div
                                                        className={classnames(styles.option, 
                                                                      (this.state.selectedOption === OPTION_BUY_REMOTES) ? styles.selected : null
                                                        )}
                                                        onClick={() => this.onOptionClick(OPTION_BUY_REMOTES)}
                                                    >
                                                        <div className={styles.title}>{ strings('extraVRoptionTitleBuy') }</div>
                                                        <div>{ strings('extraVRoptionBuy') }</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    
                                    {
                                        ((this.state.selectedOption === OPTION_MANAGE_REMOTES) &&
                                        houseHasSubscriptions &&
                                        <div className={styles.section} data-section="1">
                                            {
                                                !this.state.isLoading &&
                                                <>
                                                <div className={styles.overtitle}>
                                                    { strings('mySubscriptions') }
                                                </div>
                                                
                                                {
                                                    this.state.isLoadingSubscriptions ?
                                                    <Loader
                                                        gray
                                                        large
                                                        spinner
                                                        centerHorizontal
                                                        className={styles.subscriptionsLoader}
                                                    />
                                                    :
                                                    this.state.selectedHouse?.subscriptions?.map(s =>
                                                        <SubscriptionView
                                                            key={s.id}
                                                            subscription={s}
                                                            allVirtualRemotes={this.getAllVirtualRemotesForSubscription(s.id)}
                                                            house={this.state.selectedHouse}
                                                            onSubscriptionChanged={this.onSubscriptionChanged.bind(this)}
                                                        />
                                                    )
                                                }
                                                
                                                <form
                                                    action={`${API.URL}VirtualRemoteSubscriptions/create-portal-session`}
                                                    method="POST"
                                                    onSubmit={(event) => this.onSubmitPortalSession(event)}
                                                    className={styles.manageButtonContainer}
                                                >
                                                    <input type="hidden" name="customerEmail" value={this.state.user?.email} />
                                                    <input type="hidden" name="houseId" value={this.state.selectedHouse?.id} />
                                                    <AntdButton
                                                        loading={this.state.isCreatingPortalSession}
                                                        htmlType="submit"
                                                        className={styles.manageButton}
                                                        size="large"
                                                        type="primary"
                                                    >
                                                        { strings('manageYourSubscriptions') }
                                                    </AntdButton>
                                                </form>
                                                </>
                                            }
                                        </div>)
                                    }
                                    {
                                        (this.state.selectedOption === OPTION_BUY_REMOTES) &&
                                        <div className={styles.section} data-section="2">                                            
                                            <div className={styles.subtitleDark}>
                                                { strings('extraVRoptionBuySubtitle') }
                                            </div>
                                            
                                            {
                                                this.isGuestInHouse(this.state.selectedHouse) ?
                                                <div className={styles.section}>
                                                    <div className={classnames(styles.sectionContent, styles.sectionContentMessage)}>
                                                        <img src={InfoIcon} />
                                                        <div>
                                                            <span className={styles.purpleText}>{ strings('extraVRsGuestBanner1') }</span>{ strings('extraVRsGuestBanner2') }
                                                            <br/><br/>
                                                            { strings('extraVRsGuestBanner3') }
                                                        </div>
                                                    </div>
                                                </div>
                                                :
                                                <>
                                                    <div className={styles.sectionContent}>
                                                        <div className={styles.products}>
                                                            { this.renderProducts() }
                                                        </div>
                                                    </div>
                                                    
                                                    {
                                                        shouldShowDelegatePayment &&
                                                        <div className={styles.sectionBanner}>
                                                            <div className={styles.titleContainer}>
                                                                <img src={InfoIcon} />
                                                                <div className={styles.title}>{ strings('extraVRsubtitleDelegatePaymentTitle') }</div>
                                                            </div>
                                                            <div className={styles.subtitle}>{ strings('extraVRsubtitleDelegatePayment') }</div>
                                                        </div>
                                                    }
                                                </>
                                            }
                                            
                                            { this.renderInfoSection() }
                                        </div>
                                    }
                                </div>
                                
                                <Modal
                                    title={<>{strings('extraVRdoorsInfoModalTitle')} <span className={styles.purpleText}>{this.state.selectedHouse?.name}</span></>}
                                    visible={this.state.isDoorsInfoModalVisible}
                                    footer={null}
                                    onCancel={() => this.setState({ isDoorsInfoModalVisible: false })}
                                    centered
                                    bodyStyle={{ paddingTop: 0 }}
                                    autoFocusButton={null}
                                    className={styles.modalInfoDoors}
                                >
                                    { this.renderDoorItems(this.state.selectedHouse) }
                                </Modal>
                            </>
                        }
                        {
                            this.state.isLoading &&
                            this.state.selectedHouse == null &&
                            <>
                                <Skeleton active />
                                <Skeleton active />
                            </>
                        }
                    </div>
                </div>
            </div>
        )
    }
    renderHouses()
    {
        let noHouses = this.state.houses.length === 0 && !this.state.isLoading
        
        return (
            (!noHouses) ?
            <div className={styles.housesContainer}>
                {
                    (this.state.houses.length > 1) &&
                    <div className={styles.housesHeader}>
                        { strings('extraVRHousesHeader') }
                    </div>
                }
                
                <div className={styles.houses}>
                    {
                        this.state.houses.map(house =>
                        <div
                            key={house.id}
                            id={'house-'+house.id}
                            className={classnames([styles.house, (this.state.selectedHouse?.id === house.id) && styles.selected])}
                            onClick={() => this.onHouseClick(house)}
                        >
                            <div className={styles.top}>
                                <div className={styles.houseName}>
                                    <span className={styles.houseIcon}>
                                        { Utils.getHouseTypeIcon(house) }
                                    </span>
                                    <span>{ house.name }</span>
                                </div>
                            </div>
                            {
                                this.renderDoorItems(house)
                            }
                        </div>)
                    }
                </div>
            </div>
            :
            <div className={styles.noHousesContainer}>
                <div className={styles.noHousesBanner}>
                    { strings('extraVRsNoHouses') }
                    
                    <form
                        action={`${API.URL}VirtualRemoteSubscriptions/create-portal-session`}
                        method="POST"
                        onSubmit={(event) => this.onSubmitPortalSession(event)}
                    >
                        <input type="hidden" name="customerEmail" value={this.state.user?.email} />
                        <AntdButton
                            loading={this.state.isCreatingPortalSession}
                            htmlType="submit"
                            className={styles.button}
                            size="medium"
                            type="primary"
                        >
                            { strings('manageYourSubscriptions') }
                        </AntdButton>
                    </form>
                </div>
            </div>
        )
    }
    renderDoorItems(house)
    {
        return (
            (house.doors != null) ?
            house.doors.map(door => this.renderDoorItem(door))
            :
            (
                (house.nodes != null) ?
                house.nodes.map(node => node.doors.map(door => this.renderDoorItem(door)))
                :
                null
            )
        )
    }
    renderDoorItem(door)
    {
        let isAdmin = (door.roleType === 'admin')
        let myUserId = API.getInstance().getUserId()
        let virtualRemotes = door.myPermission?.virtualRemotes
        
        let extraCountWhenNotAdmin = (!isAdmin &&
                                        !door.myPermission?.virtualRemotes?.some(vr => vr.assignedUserId === myUserId) 
                                        ? 1 : 0)
        
        let totalRemotes = virtualRemotes?.length + extraCountWhenNotAdmin
        let availableRemotes = isAdmin ? virtualRemotes?.filter(vr => vr.ownerUserId == myUserId && !vr.assignedUserId && !vr.reserved).length :
                                         virtualRemotes?.filter(vr => !vr.assignedUserId && !vr.reserved).length
        let inUseRemotes = totalRemotes - availableRemotes
        
        return (
            <div key={door.id} className={styles.door}>
                <div>{ door.name }</div>
                <div className={styles.remotesCountBox}>
                    <div>
                        <div className={styles.count}>{ totalRemotes }</div>
                        <div className={styles.text}>{ strings('totalRemotes2') }</div>
                    </div>
                    <div>
                        <div className={styles.count}>{ availableRemotes }</div>
                        <div className={styles.text}>{ strings('availableRemotes') }</div>
                    </div>
                    <div>
                        <div className={styles.count}>{ inUseRemotes }</div>
                        <div className={styles.text}>{ strings('inUseRemotes') }</div>
                    </div>
                </div>
            </div>
        )
    }
    
    renderProducts()
    {
        if (this.state.isLoading || this.state.isLoadingProducts)
            return null

        let shouldShowDelegatePayment = this.getShouldShowDelegatePayment()
        let annualProduct = this.state.products.find(p => !isFiveYearProduct(p))

        return this.state.products.map(product =>
        {
            let pricing = buildPricingModel(product, annualProduct)

            if (pricing == null)
                return null

            return (
                <ProductCard
                    key={product.id}
                    product={product}
                    pricing={pricing}
                    isOpen={this.state.expandedProductIds.includes(product.id)}
                    onToggle={() => this.onToggleProductTiers(product.id)}
                >
                    <form
                        action={`${API.URL}VirtualRemoteSubscriptions/create-checkout-session`}
                        method="POST"
                        onSubmit={(event) => this.onSubmitCheckoutSession(event, product)}
                    >
                        <input type="hidden" name="priceId" value={product.default_price?.id} />
                        <input type="hidden" name="customerEmail" value={this.state.user?.email} />
                        <input type="hidden" name="houseId" value={this.state.selectedHouse?.id} />

                        {
                            shouldShowDelegatePayment &&
                            <div className={styles.productSwitchContainer}>
                                <div>{ strings('delegatePaymentSwitchLabel') }</div>
                                <Switch
                                    checked={this.state.isTrialChecked}
                                    onChange={this.onChangedSwitch.bind(this)}
                                />
                            </div>
                        }

                        <Button
                            type="submit"
                            title={strings('select')}
                            isLoading={this.state.isCreatingSessionProductId === product.id}
                        />
                    </form>
                </ProductCard>
            )
        })
    }

    renderInfoSection()
    {
        return (
            <div className={styles.infoSection}>
                <div className={styles.delegatePaymentBlock}>
                    <img
                        className={styles.delegatePaymentIcon}
                        src={require('../../img/icons/person.2.fill.svg').default}
                        alt=""
                    />
                    <div>
                        <div className={styles.delegatePaymentTitle}>
                            { strings('delegatePaymentCommunityTitle') }
                        </div>
                        <div className={styles.delegatePaymentText}>
                            { strings('delegatePaymentCommunityText1') }
                            <a href={`mailto:${SUPPORT_EMAIL}`}>{ SUPPORT_EMAIL }</a>
                            { strings('delegatePaymentCommunityText2') }
                        </div>
                    </div>
                </div>

                <div className={styles.benefitsBlock}>
                    <Disclosure
                        id="vr-benefits"
                        label={`\ud83d\udc8e ${strings('vrBenefits')}`}
                        isOpen={this.state.isBenefitsOpen}
                        onToggle={() => this.setState({ isBenefitsOpen: !this.state.isBenefitsOpen })}
                        triggerClassName={styles.benefitsTrigger}
                    >
                        <VRBenefits />
                    </Disclosure>
                </div>
            </div>
        )
    }

    onToggleProductTiers(productId)
    {
        let expandedProductIds = this.state.expandedProductIds.includes(productId) ?
                                    this.state.expandedProductIds.filter(id => id !== productId)
                                    :
                                    [...this.state.expandedProductIds, productId]

        this.setState({ expandedProductIds })
    }

    onHouseClick(house)
    {
        if (house == null || house.id == this.selectedHouse?.id)
            return
        this.setState({ selectedHouse: house, isTrialChecked: false, selectedOption: null })
        
        this.props.history.push({search: `house_id=${house.id}`})
        
        this.virtualRemotesByHouse = null
        this.getVirtualRemotesByHouse(house.id)
        
        //Scroll to top of right div element
        let rightDiv = document.getElementById('extraVrsRight')
        if (rightDiv != null)
            rightDiv.scrollTo(0,0)
    }
    onChangedSwitch(checked)
    {
        this.setState({ isTrialChecked: checked })
    }
    onClickGoBack()
    {
        this.setState({ selectedOption: null })
    }
    
    async onSubmitPortalSession(event)
    {
        event.preventDefault()
        
        this.setState({ isCreatingPortalSession: true })
        
        try
        {
            let res = await API.getInstance().createPortalSession(this.state.user?.email, this.state.selectedHouse?.id)
            
            try
            {
                if (res.data?.response)
                    window.open(res.data?.response, '_blank').focus()
            }
            catch(error)
            {
                console.log(error)
                alert(strings('openManageInStripeWindowBlockedError'))
            }
        }
        catch(error)
        {
            console.log(error)
            
            notification.error(
            {
                description: strings('error'),
                placement: 'top'
            })
        }
        finally
        {
            setTimeout(() =>
            {
                this.setState({ isCreatingPortalSession: false })
            }, 1000)
        }
    }
    async onSubmitCheckoutSession(event, product)
    {
        event.preventDefault()
        
        this.setState({ isCreatingSessionProductId: product.id })
        
        try
        {
            let res = await API.getInstance()
                            .createCheckoutSession(this.state.user?.email,
                                                    this.state.selectedHouse?.id,
                                                    product.default_price?.id,
                                                    this.state.isTrialChecked)
            if (res.data?.response?.url)
                window.location.replace(res.data?.response?.url)
        }
        catch(error)
        {
            console.log(error)
            
            notification.error(
            {
                description: strings('error'),
                placement: 'top'
            })
        }
        finally
        {
            setTimeout(() =>
            {
                this.setState({ isCreatingSessionProductId: null })
            }, 1000)
        }
    }
    
    getMyPermissions()
	{
        this.setState({ isLoading: true })
        
		API.getInstance().getHouses()
		.then(response =>
		{
            this.houses = []
            let houses = []
            
            response.data.map((permission) =>
            {
                if (permission.activationDate != null &&
                    permission.PermissionNode != null &&
                    permission.PermissionNode.PermissionHouse != null)
                {
                    const permissionNode = permission.PermissionNode;
                    const permissionHouse = permissionNode.PermissionHouse;
                    const permissionDoor = permission.PermissionDoor;

                    var house = houses.find(h => h.id === permissionHouse.id);
                    if (house == null)
                    {
                        house =
                        {
                            id: permissionHouse.id,
                            userId: permissionHouse.userId,
                            name: permissionHouse.name,
                            doors: [],
                            nodeId: permissionNode.id,
                            place: permissionHouse.place,
                            type: permissionHouse.type,
                            hasTrial: permissionHouse.hasTrial
                        }
                        houses.push(house);
                    }

                    var d =
                    {
                        id: permissionDoor.id,
                        name: permissionDoor.name,
                        permissionId: permission.id,
                        roleType: permission.roleType,
                        hubId: permissionNode.hubId,
                        actuatorId: permissionDoor.actuatorId,
                        sensorId: permissionDoor.sensorId,
                        isOpen: permissionDoor.isOpen,
                        changeStatusAt: permissionDoor.changeStatusAt,
                        houseId: permissionHouse.id,
                        node: permissionNode
                    }
                    d.imageURL = null;
                    if (permissionDoor.imageURL != null)
                    {
                        d.imageURL = (permissionDoor.imageURL.indexOf('http') > -1 || permissionDoor.imageURL.indexOf('file:') > -1) ?
                                        permissionDoor.imageURL
                                        :
                                        `${API.URL}${permissionDoor.imageURL.slice(1, permissionDoor.imageURL.length)}?access_token=${API.getInstance().getToken()}`;
                    }
                    else
                        d.imageURL = `${API.URL}Doors/${permissionDoor.id}/image?access_token=${API.getInstance().getToken()}`

                    d.myPermission = {}
                    if (permission.startDate != null)
                        d.myPermission.startDate = permission.startDate;

                    if (permission.endDate != null)
                        d.myPermission.endDate = permission.endDate;

                    if (permission.PermissionDays != null)
                        d.myPermission.permissionDays = [...permission.PermissionDays];
                    
                    if (permission.virtualRemotes != null)
                        d.myPermission.virtualRemotes = [...permission.virtualRemotes]
                        
                    if (permission.assignedVirtualRemote != null)
                        d.myPermission.assignedVirtualRemote = permission.assignedVirtualRemote

                    house.doors.push(d);
                }
            });

            this.houses = houses;

            this.onFinishedGettingHouses();
		})
		.catch(error =>
		{
			console.log(error)

            this.setState({ isLoading: false })
            
            notification.error(
            {
                //message: this.state.name,
                description: strings('garagesError'),
                placement: 'top'
            })
		});
	}
    async onFinishedGettingHouses()
    {
        let user = null
        try
        {
            user = await API.getInstance().getCurrentUser()
            this.setState({ user })
        }
        catch(e)
        {
            console.log(e)
        }
        
        if (user != null && (user.email.includes('@primaprix.es') ||
                             user.email.includes('@vasbe.com')))
        {
            this.houses.sort((houseA, houseB) =>
            {
                if (houseA.name < houseB.name) { return -1 }
                if (houseA.name > houseB.name) { return 1 }
                return 0
            })
        }
        
        
        API.getInstance().setMainHouses(this.houses)
        
        this.setState(
        {
            houses: this.getFilteredHousesBySearch(),
            isLoading: false
        }, () =>
        {
            if (this.houses.length > 0)
            {                
                // Search for url query params to select door if needed
                let searchParams = qs.parse(this.props.location.search, { ignoreQueryPrefix: true })
                let success = (searchParams.success != null) ? (JSON.parse(searchParams.success) == true) : null
                let canceled = (searchParams.canceled != null) ? (JSON.parse(searchParams.canceled) == true) : null
                
                if (searchParams.house_id)
                {
                    let house = this.houses.find(h => h.id == searchParams.house_id)
                    if (house != null)
                    {
                        this.onHouseClick(house)
                        setTimeout(() =>
                        {
                            let houseDiv = document.getElementById('house-'+searchParams.house_id)
                            if (houseDiv != null)
                                houseDiv.scrollIntoView({behavior: "smooth", block: "nearest", inline: isMobile ? "start" : "center"})
                                
                            if (searchParams.selected_option)
                            {
                                if (searchParams.selected_option === OPTION_MANAGE_REMOTES)
                                    this.setState({ selectedOption: OPTION_MANAGE_REMOTES })
                                else if (searchParams.selected_option === OPTION_BUY_REMOTES)
                                    this.setState({ selectedOption: OPTION_BUY_REMOTES })
                                    
                                this.props.history.push({search: `house_id=${house?.id}&selected_option=${searchParams.selected_option}`})
                            }
                        }, 500)
                    }
                    else
                        this.onHouseClick(this.houses[0])
                }
                else
                    this.onHouseClick(this.houses[0])
                    
                if (success != null)
                {
                    Modal.success({
                        content: <Result
                                    status={success ? "success" : "error"}
                                    title={success ? strings('extraVRsPurchaseSuccessTitle') : strings('extraVRsPurchaseErrorTitle')}
                                    subTitle={success ? strings('extraVRsPurchaseSuccess') : strings('extraVRsPurchaseError')}
                                    />,
                        centered: true,
                        icon: null,
                        okButtonProps: { block: true, size: 'large' },
                        wrapClassName: 'blockButtons',
                        autoFocusButton: 'null'
                    })
                }
            }
        })
    }
    
    getDoor(doorId)
    {
        let door = null;

        for (let i = 0; i < this.houses.length && door == null; i++)
        {
            if (this.houses[i].doors != null)
            {
                for (let j = 0; j < this.houses[i].doors.length && door == null; j++)
                {
                    if (this.houses[i].doors[j].id === doorId)
                        door = this.houses[i].doors[j];
                }
            }
        }
        
        return door;
    }
    getShouldShowDelegatePayment()
    {
        return this.state.selectedHouse?.hasTrial && 
                ((this.state.selectedHouse?.doors && this.state.selectedHouse?.doors[0]?.roleType === 'admin') ||
                 (this.state.selectedHouse?.nodes && this.state.selectedHouse?.nodes[0]?.doors[0]?.roleType === 'admin'))
    }
    isGuestInHouse(house)
    {
        if (house.doors != null)
            return (house.doors.find(d => d.roleType === 'guest') != null)
        else if (house.nodes != null)
        {
            let isGuestInHouse = false
            for (let i = 0; i < house.nodes.length || isGuestInHouse; i++)
            {
                let n = house.nodes[i]
                isGuestInHouse = (n.doors.find(d => d.roleType === 'guest') != null)
            }
            return isGuestInHouse
        }
        else
            return false
    }
    houseHasSubscriptions(house)
    {
        let houseHasSubscriptions = false
        
        if (house?.doors != null)
        {
            for (let i = 0; i < house.doors.length && !houseHasSubscriptions; i++)
            {
                let d = house.doors[i]
                
                houseHasSubscriptions = d.myPermission?.virtualRemotes.some(vr => vr.subscription != null)
                
                if (!houseHasSubscriptions)
                    houseHasSubscriptions = d.myPermission?.assignedVirtualRemote?.subscription != null &&
                                            d.myPermission?.assignedVirtualRemote?.delegatedUserId == API.getInstance().getUserId()
            }
        }
        else if (house?.nodes != null)
        {
            for (let j = 0; j < house.nodes.length && !houseHasSubscriptions; j++)
            {
                let n = house.nodes[j]
                for (let i = 0; i < n.doors.length && !houseHasSubscriptions; i++)
                {
                    let d = n.doors[i]
                    houseHasSubscriptions = d.myPermission?.virtualRemotes.some(vr => vr.subscription != null)
                    
                    if (!houseHasSubscriptions)
                        houseHasSubscriptions = d.myPermission?.assignedVirtualRemote?.subscription != null &&
                                                d.myPermission?.assignedVirtualRemote?.delegatedUserId == API.getInstance().getUserId()
                }
            }
        }
        
        if (!houseHasSubscriptions && this.state.selectedOption != OPTION_BUY_REMOTES)
            this.setState({ selectedOption: OPTION_BUY_REMOTES })
        
        return houseHasSubscriptions
    }
    getAllVirtualRemotesForSubscription(subscriptionId)
    {
        return this.virtualRemotesByHouse.filter(vr => (vr.subscription?.id === subscriptionId) ||
                                                        (subscriptionId === 'permanent' && vr.subscription === null))
    }
    
    async getVirtualRemotesByHouse(houseId)
    {
        if (!this.state.isLoadingSubscriptions)
            this.setState({ isLoadingSubscriptions: true })
        
        try
        {
            let res = await API.getInstance().getVirtualRemotesByHouse(houseId)
            
            let myUserId = API.getInstance().getUserId()
            
            const filterMyRemotes = (vr) => (vr.ownerUserId === myUserId && (vr.delegatedUserId == null || vr.delegatedUserId == 0 || vr.delegatedUserId === myUserId)) ||
                                             vr.delegatedUserId === myUserId
            
            this.virtualRemotesByHouse = res.data.virtualRemotes.filter(filterMyRemotes)
            //console.log(this.virtualRemotesByHouse)
            
            // We get rid of duplicate VRs
            let filteredVirtualRemotes = res.data.virtualRemotes.filter((v,i,a)=>a.findIndex(v2=>(v2.virtualRemoteId===v.virtualRemoteId))===i)
            //console.log(filteredVirtualRemotes)
            
            // Get only the remotes I own and that have no delegation
            filteredVirtualRemotes = filteredVirtualRemotes.filter(filterMyRemotes)
            //console.log(filteredVirtualRemotes)

            let subscriptions = Utils.getSubscriptionsFromVirtualRemotes(filteredVirtualRemotes)
            //console.log(subscriptions)
            
            if (this.state.selectedHouse?.id === houseId)
                this.setState({ selectedHouse: {...this.state.selectedHouse, subscriptions} })
        }
        catch(error)
        {
            console.log(error)
            
            /*notification.error(
            {
                description: strings('error'),
                placement: 'top'
            })*/
        }
        finally
        {
            this.setState({ isLoadingSubscriptions: false })
        }
    }
    async getStripeProducts()
    {
        this.setState({ isLoadingProducts: true })
        
        try
        {
            let res = await API.getInstance().getStripeProducts()
            let products = res.data?.response?.reverse() ?? []
            
            // Keep the two subscription products and always show the annual one first
            products = products.slice(0, 2)
                               .filter(p => p != null)
                               .sort((a, b) => (isFiveYearProduct(a) ? 1 : 0) - (isFiveYearProduct(b) ? 1 : 0))
            
            this.setState({ products })
        }
        catch(error)
        {
            console.log(error)
            
            notification.error(
            {
                description: strings('error'),
                placement: 'top'
            })
        }
        finally
        {
            this.setState({ isLoadingProducts: false })
        }
    }
    
    onOptionClick(selectedOption)
    {
        this.props.history.push({search: `house_id=${this.state.selectedHouse?.id}&selected_option=${selectedOption}`})
        this.setState({ selectedOption })
    }
    
    onSubscriptionChanged()
    {
        let cleanHouse = {...this.state.selectedHouse}
        delete cleanHouse.subscriptions
        
        this.setState({ selectedHouse: cleanHouse, isLoadingSubscriptions: true }, () =>
        {
            setTimeout(() =>
            {
                this.virtualRemotesByHouse = null
                this.getVirtualRemotesByHouse(this.state.selectedHouse?.id)
            }, 2000)
        })
    }
    
    /************ SEARCH ************/
    onSearchInput(event)
    {
        let input = event?.target?.value?.trim()
        
        this.setState({ searchInput: input }, () =>
        {
            // No search -> reset houses
            if (input.length === 0)
            {
                this.setState({
                    houses: this.houses,
                    searchInput: null
                })
            }
            
            if (input.length < 3)
                return
                                  
            this.setState({ houses: this.getFilteredHousesBySearch() })
        })
    }
    getFilteredHousesBySearch()
    {
        let filteredHouses = this.houses
        let searchStr = this.state.searchInput?.toLowerCase()
        
        if (searchStr != null)
        {
            // Filter houses
            filteredHouses = this.houses?.filter(h => ( h.name.toLowerCase().includes(searchStr) ||
                                                        h?.doors?.some(d => d.name.toLowerCase().includes(searchStr)) ||
                                                        h?.nodes?.some(n => n?.doors?.some(d => d.name.toLowerCase().includes(searchStr))) ))
        }
        
        return filteredHouses
    }
    /************ SEARCH ************/
}

export default withRouter(ExtraVirtualRemotesPage)